import type { PayloadAction } from '@reduxjs/toolkit';

import type { TLoansStatusesClientResponse } from 'shared/types/TLoansService';

import { updateOnlineGroupElements, isMplPreApprovalOfferElement } from '../../lib';
import { selectOnlineGroup } from '../creditSelection.selectors';
import type { ScenarioState } from '../scenario.slice';

export const setMplOffersStatusesData = (
  state: ScenarioState,
  { payload }: PayloadAction<TLoansStatusesClientResponse>,
) => {
  const onlineGroup = selectOnlineGroup({ scenario: state });

  if (!onlineGroup || !onlineGroup.elements || !Array.isArray(payload)) {
    return;
  }

  const statusMap = new Map(payload.map((status) => [status.productId, status]));

  const elements = onlineGroup.elements.map((offer) => {
    if (!isMplPreApprovalOfferElement(offer)) {
      return offer;
    }
    const statusInfo = statusMap.get(offer.productId);

    if (statusInfo?.loansStatus) {
      return {
        ...offer,
        apiStatus: statusInfo.loansStatus,
      };
    }

    return offer;
  });

  updateOnlineGroupElements(state, elements);
};
